import * as React from 'react';

import {StackLegacy} from 'shells/layout/stack/stack-legacy';
import {Body} from 'shells/typography/body';

import {AgentCard} from './agent-card/agent-card';
import {ALL_AGENT_KEYS, SALES_PROCESS_AGENT} from './helpers';
import type {AgentKey} from './helpers';

type Props = {
    onSelectAgent: (agentKey: AgentKey) => void | null | undefined;
    isLoadingOutcomeLimits: boolean;
    userCanAccessSetup: boolean;
};

export function TeamAiAgentList(props: Props) {
    let agents = ALL_AGENT_KEYS;

    if (!props.userCanAccessSetup) {
        // @ts-expect-error
        agents = agents.filter((agentKey) => agentKey !== SALES_PROCESS_AGENT);
    }

    return (
        <StackLegacy spacing={16}>
            <Body>Chat with these agents to improve your overall experience and workflow</Body>
            <div>
                <StackLegacy spacing={8}>
                    {agents.map((agentKey) => (
                        <AgentCard
                            key={agentKey}
                            agentKey={agentKey}
                            onClick={() => {
                                if (props.onSelectAgent) {
                                    props.onSelectAgent(agentKey);
                                }
                            }}
                            isDisabled={!props.onSelectAgent || props.isLoadingOutcomeLimits}
                        />
                    ))}
                </StackLegacy>
            </div>
        </StackLegacy>
    );
}
